<template>
    <v-row v-if="!$store.getters.progress" class="pb-offset ma-0">
		<v-col class="pa-0 pb-4">
            <v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">{{ id ? 'Modifica' : 'Nuovo'}} Ruolo</p>
                    <v-spacer></v-spacer>
                </v-card-title>        
                <v-divider></v-divider>
                <v-container class="pa-4" fluid>
                    <fields-generator
                        v-if="loaded"
                        :fieldsset.sync="fieldsset"
                        :model.sync="model"
                        ref="fieldsgenerator"
                    ></fields-generator>
                    <!-- Solo HR: dashboard su I miei dati e menu tutto al primo livello per chi ha il ruolo -->
                    <v-row class="ma-0" v-if="loaded && $store.getters.getProfile.hr_module_enabled">
                        <v-switch
                            color="primary"
                            inset
                            class="flex pt-2 pl-3 pb-0"
                            v-model="model.hr_only"
                            label="Solo HR"
                            hint="Dashboard su I miei dati e menu tutto al primo livello"
                            persistent-hint
                        ></v-switch>
                    </v-row>
                </v-container>
            </v-card>
        </v-col>

        <v-col class="pb-4 pa-0" cols="12" v-if="loaded && $store.getters.checkSettings('api_permission')">
            <v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Permessi API</p>
                    <v-spacer></v-spacer>
                </v-card-title>        
                <v-divider></v-divider>
                <v-container class="pa-4" fluid>

                    <v-row class="ma-0">
                        <v-switch color="primary" inset class="flex pt-2 pl-3 pb-0" v-model="model['open_api']" label="Attiva OPENAPI"></v-switch>
                    </v-row>

                    <template v-if="model['open_api']">
                        <v-row class="ma-0" v-for="(api_permission, ap) in api_permissions" :key="ap">
                            <v-col class="pa-4" cols="2">
                                <v-checkbox
                                    v-model="api_permissions_selected[api_permission.value]['status']"
                                    :label="api_permission.text"
                                    hide-details
                                    class="ma-auto"
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field
                                    v-if="api_permissions_selected[api_permission.value].status"
                                    label="Richieste Mensili*"
                                    type="number"
                                    width="100px"
                                    v-model.number="api_permissions_selected[api_permission.value]['max_request']"
                                    :error-messages="errors.collect(api_permission.value)"
                                    :data-vv-name="api_permission.value"
                                    v-validate="'required'"
                                    hide-details
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <small class="px-4">Le richieste mensili sono infinite se valorizzato con 0</small>
                    </template>
                </v-container>
            </v-card>
        </v-col>

        <v-col class="pb-3 pa-0" cols="12">
            <v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Permessi</p>
                    <v-spacer></v-spacer>
                    <v-btn small text color="primary" @click="setAllPermissions('true')" v-if="loaded">
                        <v-icon left small>mdi-check-all</v-icon>
                        Attiva tutto
                    </v-btn>
                    <v-btn small text @click="setAllPermissions('false')" class="ml-2" v-if="loaded">
                        <v-icon left small>mdi-close-box-multiple-outline</v-icon>
                        Disattiva tutto
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-expansion-panels multiple inset focusable v-if="loaded">
                    <v-expansion-panel v-for="(module, module_name, m) in modules_permissions" :key="m">
                        <v-expansion-panel-header class="background-2">
                            <div class="d-flex align-center" style="width: 100%">
                                <span>{{ $trans(module_name) }}</span>
                                <v-spacer></v-spacer>
                                <v-btn small text color="primary" class="mr-3" @click.stop="setModulePermissions(module_name, 'true')">
                                    <v-icon left small>mdi-check-all</v-icon>
                                    Attiva tutto
                                </v-btn>
                                <v-btn small text class="mr-3" @click.stop="setModulePermissions(module_name, 'false')">
                                    <v-icon left small>mdi-close-box-multiple-outline</v-icon>
                                    Disattiva tutto
                                </v-btn>
                            </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content id="role-permissions" class="background-3 pa-2 pb-0">
                            <v-card v-for="(submodule, submodule_name, s) in module" :key="s" class="background-2 mb-2">
                                <div class="d-flex align-center pl-2 pb-2 pr-3">
                                    <v-subheader class="pl-3 pt-3">{{ $trans(submodule_name) }}</v-subheader>
                                    <v-spacer></v-spacer>
                                    <v-btn small text color="primary" class="mr-2" @click="setSubmodulePermissions(submodule_name, 'true')">
                                        <v-icon left small>mdi-check-all</v-icon>
                                        Attiva tutto
                                    </v-btn>
                                    <v-btn small text @click="setSubmodulePermissions(submodule_name, 'false')">
                                        <v-icon left small>mdi-close-box-multiple-outline</v-icon>
                                        Disattiva tutto
                                    </v-btn>
                                </div>
                                <v-row class="ma-0 px-3" v-if="typeof submodule['index'] !== 'undefined' && (!submodule['index'].options || submodule['index'].options.length <= 2)">
                                    <!-- Index booleano (legacy): v-switch true/false -->
                                    <v-col class="py-0" lg="3" md="3" sm="6" cols="12">
                                        <v-switch @change="setRadios(submodule_name, $event)" color="primary" inset class="flex pt-2 pl-3 pb-0" v-if="typeof radio_permissions[submodule_name]['index'] !== 'undefined'" v-model="radio_permissions[submodule_name]['index']" false-value="false" true-value="true" label="Index"></v-switch>
                                    </v-col>
                                </v-row>
                                <v-container class="pa-0" fluid>
                                    <v-row class="ma-0">
                                        <template v-for="(action, action_name, a) in submodule">
                                            <!-- Index con scope multipli (HR): radio come le altre azioni -->
                                            <v-col class="py-0" lg="3" md="3" sm="6" cols="12" :key="a" v-if="action_name === 'index' && action.options && action.options.length > 2">
                                                <v-card-text class="background-2 pa-0 pl-5">
                                                    <v-subheader class="pl-0 text-capitalize">{{ action.name }}</v-subheader>
                                                    <v-radio-group v-model="radio_permissions[submodule_name]['index']" class="pt-0" column>
                                                        <v-radio v-for="(option_name, o) in action.options" color="primary" :label="$eventBusUtility.transOptionsRole(option_name)" :value="option_name" :key="o"></v-radio>
                                                    </v-radio-group>
                                                </v-card-text>
                                            </v-col>
                                            <v-col class="py-0" lg="3" md="3" sm="6" cols="12" :key="a + '-act'" v-if="action_name !== 'index' && action.options && action.options.length >= 2">
                                                <v-card-text class="background-2 pa-0 pl-5">
                                                    <v-subheader class="pl-0 text-capitalize">{{ action.name }}</v-subheader>
                                                    <v-radio-group v-model="radio_permissions[submodule_name][action_name]" class="pt-0" column>
                                                        <v-radio v-for="(option_name, o) in action.options" color="primary" :label="$eventBusUtility.transOptionsRole(option_name)" :value="option_name" :key="o"></v-radio>
                                                    </v-radio-group>
                                                </v-card-text>
                                            </v-col>
                                            <!-- Fallback switch solo quando options non definite -->
                                            <v-col class="py-0" lg="3" md="3" sm="6" cols="12" :key="a + '-sw'" v-if="action_name !== 'index' && (!action.options || action.options.length < 2)">
                                                <v-switch v-if="typeof radio_permissions[submodule_name] !== 'undefined' && typeof radio_permissions[submodule_name][action_name] !== 'undefined'" color="primary" inset class="flex pt-2 pl-3 pb-0 text-capitalize" v-model="radio_permissions[submodule_name][action_name]" false-value="false" true-value="true" :label="action.name"></v-switch>
                                            </v-col>
                                        </template>
                                    </v-row>
                                </v-container>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card>
        </v-col>
        <v-tooltip top>
            <template v-slot:activator="{ on: tooltip }">
                <v-fab-transition slot="activator">
                    <v-btn
                        v-on="{ ...tooltip }" 
                        v-show="!$store.getters.progress"
                        @click.native="saveRole"
                        :loading="saved"
                        color="primary"
                        dark
                        fixed
                        bottom
                        right
                        fab>
                        <v-icon>mdi-sync</v-icon>
                    </v-btn>
                </v-fab-transition>
            </template>
            <span>Crea</span>
        </v-tooltip>
    </v-row>
</template>

<script>

    export default {
        name: 'role-editor',
        props: {
            id: Number,
            defaultInput: Object,
        },
        data() {
            return {
                model: {},
                url: 'roles/',
                saved: false,
                loaded: false,
                modules_permissions: [],
                radio_permissions: {},
                api_permissions: [],
                api_permissions_selected: {},
                fieldsset: {},
                act: {},
            }
        },

        created() {
            if(this.id) {
                    this.axios.get('roles/' + this.id + '/edit').then(response => {
                    // get body data
                    this.fieldsset = response.data.fields.fields
                    this.model = response.data.model
                    this.$set(this, 'modules_permissions', response.data.fields.modules_permissions)
                    this.$set(this, 'api_permissions', response.data.fields.api_permission)
                    this.$set(this, 'radio_permissions', response.data.model.permissions)
                    this.$set(this, 'api_permissions_selected', response.data.model.api_permissions)

                    if(this.api_permissions_selected == null || this.api_permissions_selected == undefined) {
                        this.api_permissions_selected = {}
                        _.forEach(this.api_permissions, (value, key) => {
                            this.$set(this.api_permissions_selected, [value.value], {status: false, max_request: 0})
                        })                         
                    }
                    this.loaded = true

                    this.$store.commit('endProgress')

                }, response => {
                    // error callback
                })

            } else {
                this.axios.get('roles/create').then(response => {
                    // get body data
                    this.fieldsset = response.data.fields.fields
                    this.$set(this, 'modules_permissions', response.data.fields.modules_permissions)
                    this.$set(this, 'api_permissions', response.data.fields.api_permission)
    
                    _.forEach(this.api_permissions, (value, key) => {
                         this.$set(this.api_permissions_selected, [value.value], {status: false, max_request: 0})
                    }) 
    
                    this.loaded = true
    
                    this.initialize('false')
                    this.$store.commit('endProgress')
    
                }, response => {
                    // error callback
                })
            }

        },

        methods: {
            initialize(val) {
                _.forEach(this.modules_permissions, (module_permission, module_name) => {
                    _.forEach(module_permission, (submodule, submodule_name) => {
                        let act = {}
                        // Set default values for all permissions including audit
                        _.forEach(submodule, (action, action_name) => {
                            act[action_name] = val
                        })
                        // Ensure audit is set to false by default if not present
                        act['audit'] = act['audit'] || 'false'
                        this.$set(this.radio_permissions, submodule_name, act)
                    })
                })
            },

            setRadios(submodule_name, event) {
                if (!this.radio_permissions[submodule_name]) {
                    this.$set(this.radio_permissions, submodule_name, {})
                }
                if(event == 'false' ) {
                    _.forEach(this.radio_permissions[submodule_name], (value, key) => {
                        this.$set(this.radio_permissions[submodule_name], key, 'false')
                    })
                }
            },

            setSubmodulePermissions(submodule_name, value) {
                let submoduleDef = null
                _.forEach(this.modules_permissions, (module_permission) => {
                    if (module_permission[submodule_name]) {
                        submoduleDef = module_permission[submodule_name]
                    }
                })
                if (!this.radio_permissions[submodule_name]) {
                    this.$set(this.radio_permissions, submodule_name, {})
                }
                // Equivalenze: quando il valore "Attiva tutto" / "Disattiva tutto"
                // non è disponibile nelle options di un'azione, usa l'equivalente
                // semantico (es. submoduli HR scopabili dove 'true' è stato sostituito da 'all').
                const equivalents = {
                    true: ['true', 'all'],
                    false: ['false'],
                }
                _.forEach(this.radio_permissions[submodule_name], (currentValue, action_name) => {
                    const action = submoduleDef ? submoduleDef[action_name] : null
                    const options = action && Array.isArray(action.options) ? action.options : null
                    if (!options) {
                        this.$set(this.radio_permissions[submodule_name], action_name, value)
                        return
                    }
                    if (options.includes(value)) {
                        this.$set(this.radio_permissions[submodule_name], action_name, value)
                        return
                    }
                    // Cerca un valore equivalente disponibile
                    const candidates = equivalents[value] || []
                    const fallback = candidates.find(c => options.includes(c))
                    this.$set(this.radio_permissions[submodule_name], action_name, fallback || options[0])
                })
            },

            setModulePermissions(module_name, value) {
                _.forEach(this.modules_permissions[module_name], (submodule, submodule_name) => {
                    this.setSubmodulePermissions(submodule_name, value)
                })
            },

            setAllPermissions(value) {
                _.forEach(this.modules_permissions, (module_permission, module_name) => {
                    this.setModulePermissions(module_name, value)
                })
            },

            saveRole() {

                this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
                    if (!result) {
                        return false
                    }
                    this.$validator.validateAll().then(result => {
                        if (!result) {
                            return false
                        }

                        this.model['permissions'] = this.radio_permissions
                        
                        if (Object.keys(this.api_permissions_selected).length !== 0) {
                            this.model['open_api_permissions'] = this.api_permissions_selected
                        }

  
                        this.saved = true

                        if(this.id) {
                            this.axios.put('roles/' + this.id, this.model).then(response => {
                                this.$router.push({ name: 'roles-show', params: { id: parseInt(response.data.data.id) }})
                                this.saved = false
                            }, response => {
                                // error callback
                            })
                        } else {

                            this.axios.post('roles/', this.model).then(response => {
                                // get body data
                                this.$router.push({ name: 'roles-show', params: { id: parseInt(response.data.data.id) }})
                                this.saved = false
                            }, response => {
                                // error callback
                            })
                        }
                    
                    }).catch(() => {

                    })
                }).catch(() => {

                })
            },
        },
    }
</script>
<style>
    #role-permissions .expansion-panel__body {
        padding-bottom: 8px !important;
        margin-bottom: 4px !important;
    }
</style>